import { render, staticRenderFns } from "./originalSchedule.vue?vue&type=template&id=66ba4033"
import script from "./originalSchedule.vue?vue&type=script&lang=js"
export * from "./originalSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports